module.exports = __webpack_public_path__ + "img/505-c8ed28.png";